import { CartItemsCard } from "../../components/customer/cart/cart-items-card.component.tsx";
import { CartRemarksCard } from "../../components/customer/cart/cart-remarks-card.component.tsx";
import { CartStack } from "../../components/customer/cart/cart-stack.component";
import { CartOverviewSummaryCard } from "../../components/customer/cart/overview/cart-overview-summary-card.component.tsx";

export function ExternalCartOverviewPage() {
  return (
    <CartStack>
      <CartItemsCard />
      <CartRemarksCard />
      <CartOverviewSummaryCard />
    </CartStack>
  );
}
